import { atom } from "xoid";
import { useAtom } from "@xoid/react";
import { i18n } from "@/lib/i18n";

export type Language = "hu" | "en" | "de" | "sk";
const languageAtom = atom<Language>(
  (localStorage.getItem("language") as Language) ?? "hu",
);

i18n.changeLanguage(languageAtom.value);

export function useLanguage(): Language {
  const language = useAtom(languageAtom);
  return language;
}

export function setLanguage(langage: Language) {
  localStorage.setItem("language", langage);
  languageAtom.set(langage);
  i18n.changeLanguage(langage);
}

export function getCurrentLanguage() {
  return languageAtom.value;
}
